export * from "./doctor-appointment.entity/doctor-appointment";
export * from "./patient-appointment.entity/patient-appointment";
export * from "./patient-requested-appointment.entity/patient-requested-appointment";
export * from "./appointment.entity";
